import { Component } from '@angular/core'

@Component({
  selector: 'se-po-household-review-docs',
  templateUrl: './household-review-docs.component.html',
  styleUrls: ['./household-review-docs.component.scss'],
  standalone: false,
})
export class HouseholdReviewDocsComponent {
}
